<div class="jumbotron container">
    <h3 class="display-4">User succesfully logged out. To log in again please </h3>
    <p class="lead mt-3">
        <a class="btn-custom-primary btn-lable-primary" role="button" [attr.href]="url">click here</a>
    </p>
</div>